module.exports = __webpack_public_path__ + "img/SalesForce.29a6ddb2.svg";